

// export const rcheckUpload = (data) => $http.postRcheck("/rcheck/analysisPaper/analysisByFiles", data);
import request from '@/utils/request';

export const rcheckUpload = (data) => {
    return request({
        url: '/rcheck/rcheck/analysisPaper/userAnalysisByFiles',
        method: 'post',
        headers: {
            'Authorization': 'Basic Y29udHJpbWV0cmljX3dlYjpjb250cmltZXRyaWNfd2ViX3NlY3JldA=='
        },
        data: data
    });
}